import React from 'react';
export const Footer = () => {
  return <footer className="bg-[#E55A88] text-white py-6 sm:py-8 mt-8 sm:mt-12" data-id="element-84">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-8" data-id="element-85">
        <div className="flex flex-col md:flex-row justify-between items-center mb-6" data-id="element-86">
          <div className="text-xl font-bold mb-4 md:mb-0" data-id="element-87">
            <span data-id="element-88">•MENOBLOOM•</span>
          </div>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6" data-id="element-89">
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-90">
              Privacy Policy
            </a>
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-91">
              Terms of Service
            </a>
            <a href="https://trymenobloom.com/products/meno-bloom" className="hover:text-pink-100 text-sm" data-id="element-92">
              Contact Us
            </a>
          </div>
        </div>
        <div className="text-xs sm:text-sm text-pink-100 text-center" data-id="element-93">
          <p data-id="element-94">© 2025 MenoBloom Health Sciences. All Rights Reserved.</p>
          <p className="mt-2" data-id="element-95">
            *These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
        </div>
      </div>
    </footer>;
};